import Loadable from '../../components/loadable';

const ChooseDashletDrawer = Loadable({
  loader: () => import('../../pages/dashboard/components/choose_dashlet_drawer'),
});

angular.module('gym').value('ChooseDashletDrawer', ChooseDashletDrawer);
